import { DepositSchema } from '@/views/account/Deposit/styles/Deposit.styles';

export const depositStyles: DepositSchema = {
  inputCardHolderNameProps: {
    sx: {
      '&&&': {
        h: 10,
        fontSize: 'xs',
        px: 3,
        fontWeight: 'medium',
        border: 'none',
        boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)',
        bg: 'white',
        color: '#2D3748',
        fontFamily: 'body',
      },
    },
  },
};
